var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[(_vm.loading)?_c('LoadingBlock'):_vm._e(),_c('HeaderBlock',{key:Date.now(),attrs:{"logo":_vm.logo}}),_c('NavigationBill'),(_vm.transferInfo)?_c('SuccessBlock',{attrs:{"transferInfo":_vm.transferInfo}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }